export class ProjectGetBuIdRequestModel {
  /**
   * * Получить информацыю о проекте по ид проекта
   */
  ProjectId!: number;
  constructor(obj?: Partial<ProjectGetBuIdRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
